import { Edit, Delete } from "@mui/icons-material";

import { TableActions } from "../../../components/v3";

export const getMaterialTableColumns = (handleActions, hasEditMaterial, hasDeleteMaterial) => {
  const headers = [
    { field: "sl", headerName: "Sl No", flex: 0.75, sortable: false },
    {
      field: "name",
      headerName: "Material Name",
      flex: 2,
      sortable: true,
    },
    {
      field: "description",
      headerName: "Description",
      flex: 2,
      sortable: true,
    },
    {
      field: "taxPercentage",
      headerName: "Tax %",
      flex: 1,
      sortable: true,
      renderCell: (params) => (params.value ? `${params.value}%` : "-"),
    },
    {
      field: "unitOfMeasure",
      headerName: "Unit",
      flex: 1,
      sortable: true,
    },
    {
      field: "defaultPrice",
      headerName: "Price",
      flex: 1,
      sortable: true,
      renderCell: (params) => (params.value ? `₹ ${params.value}` : "-"),
    },
  ];
  if (hasEditMaterial || hasDeleteMaterial) {
    headers.push({
      field: "actions",
      headerName: "Actions",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        const actions = [];
        if (hasEditMaterial) {
          actions.push({
            icon: Edit,
            type: "edit",
            label: "Edit",
            onClick: handleActions,
          });
        }
        if (hasDeleteMaterial) {
          actions.push({
            icon: Delete,
            type: "delete",
            label: "Delete",
            onClick: handleActions,
          });
        }
        return <TableActions item={params} actions={actions} />;
      },
    });
  }
  return headers;
};
